import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GfTranslateService } from '../../../core/services/core.translate.service';

import * as _ from 'lodash';

@Component({
    selector: 'gf-module-button',
    template: require('./module-button.component.html')
})
export class ModuleButtonComponent implements OnChanges {

    @Input() module: string;
    @Input() modules = [];
    
    @Output() callback = new EventEmitter();

    protected moduleText;
    protected enabled = false;

    constructor(private gfTranslateService: GfTranslateService) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.enabled = (_.indexOf(this.modules, this.module) > -1);
        this.moduleText = (this.enabled) ? 
            this.gfTranslateService.translate('ON') :
            this.gfTranslateService.translate('OFF');
    }

    toggleModule($event) {
        this.callback.emit({ module: this.module, enabled: ! this.enabled});
        $event.target && $event.target.blur();
    };
}